module.exports = __webpack_public_path__ + "static/media/Nmb7EPdQ.cc1089dc.png";